/**
 * @ngdoc Directive
 * @name vrm-validation
 * @example
 *
 * <vrm-validation />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmValidation', vrmValidation);

    /* @ngInject */
    function vrmValidation($log, $compile) {
        return {
            scope: true,
            restrict: 'A',
            require: '^^form',
            link: link
        };

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         * @param $ctrl
         */
        function link($scope, $element, $attr, $ctrl) {

            $scope.form = $ctrl;
            $scope.control = $ctrl[$attr.name];

            // Watch for validation errors
            $scope.$watch(function() {
                return ($scope.control.$touched || $scope.form.$submitted) && $scope.control.$invalid;
            }, function(hasError) {
                $element.toggleClass('sg-error', hasError);
            });

            // Add default messages
            var $messages = $element.siblings('.vrm-form_input-errors');

            if ($messages.length === 0) {
                $element.after($compile('<div class="vrm-form_input-errors" ng-show="form.$submitted || bypassSubmitted" ng-messages="control.$error" ng-message-multiple><span ng-messages-include="messages.html"></span></div>')($scope));
            } else {
                var $messageInclude = angular.element('<span ng-messages-include="messages.html"></span>');
                $messages.append($messageInclude);
                $compile($messageInclude);
            }
        }
    }
})();
